var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"book-insight-background",style:({ 'background-color' : _vm.color, 'background-image' : `url(${_vm.shape})` })},[_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }